import { createFileRoute } from "@tanstack/react-router";
import { TicketsPage } from "@/components/pages/TicketsPage";

export const Route = createFileRoute("/tickets/")({
  component: TicketsPage,
});
